var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 19.2254C15.9905 19.2254 19.2254 15.9905 19.2254 12C19.2254 8.00955 15.9905 4.77465 12 4.77465C8.00955 4.77465 4.77465 8.00955 4.77465 12C4.77465 15.9905 8.00955 19.2254 12 19.2254ZM21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 14.5352C11.5099 14.5352 11.1127 14.1834 11.1127 13.7494L11.1127 7.50233C11.1127 7.06836 11.51 6.71656 12 6.71656C12.4901 6.71656 12.8873 7.06836 12.8873 7.50233L12.8873 13.7494C12.8873 14.1834 12.4901 14.5352 12 14.5352Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 15.5272C11.4155 15.5272 10.9418 16.001 10.9418 16.5854C10.9418 17.1698 11.4155 17.6436 11.9999 17.6436C12.5843 17.6436 13.0581 17.1698 13.0581 16.5854C13.0581 16.001 12.5843 15.5272 11.9999 15.5272Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineError);
export default __webpack_public_path__ + "static/media/line-error.5c1cb301859266135277645156360c01.svg";
export { ForwardRef as ReactComponent };